var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#close_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A5AFC3",
    d: "M12 2.56c-5.21 0-9.44 4.23-9.44 9.44s4.23 9.44 9.44 9.44 9.44-4.23 9.44-9.44S17.21 2.56 12 2.56m3.31 11.64c.31.31.31.8 0 1.11a.78.78 0 0 1-.55.23c-.2 0-.4-.08-.55-.23L12 13.1l-2.21 2.21a.78.78 0 0 1-.55.23c-.2 0-.4-.08-.55-.23a.78.78 0 0 1 0-1.11l2.21-2.21-2.21-2.21a.78.78 0 0 1 0-1.11c.31-.3.8-.3 1.11 0l2.21 2.21 2.21-2.21c.31-.3.8-.3 1.11 0 .31.31.31.8 0 1.11l-2.21 2.21 2.21 2.21z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "close_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgClose;